;(function () {
  'use strict'

  angular.module('deskfy.core').directive('coreTableColumnRowLocale', tableColumnRowLocale)

  /* @ngInject */
  function tableColumnRowLocale () {
    return {
      restrict: 'E',
      scope: {
        value: '<',
        id: '<',
        changeLoading: '<'
      },
      templateUrl:
        '/core/directives/table-columns/table-column-row-locale/table-column-row-locale-directive.html?$$REVISION$$'
    }
  }
})()
